import { types } from "../../types/types";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import ContratacionesService from "../../services/ContratacionesService";

const baseUrl = process.env.REACT_APP_API_URL;

export const setDocumentacionCargada = (estado) => {
  return (dispatch) => {
    dispatch({
      type: types.contratacionesSetDocumentacionCargada,
      payload: estado,
    });
  };
};

export const obtenerDocumentacionXSubTipoEfector = () => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      let response = null;

      response = await ContratacionesService.obtenerDocumentacionXSubTipoEfector(dataContrato.idSubTipoEfector)
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.contratacionesGetDocumentacionXSubTipoEfector,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getDocumentoEfectorFac = (idDocumentoEfectorFac) => {
  return async (dispatch) => {
    try {
      const response = await ContratacionesService.obtenerDocumentacionXPorEfector(idDocumentoEfectorFac)
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.contratacionesGetDocumentacionEF,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const setDocumentoEfectorFac = (formData, idTipoDocumentacion) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/EfectorFacturacionDocumentacion/${dataContrato.idEfectorFacturacion}/${idTipoDocumentacion}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentoEfectorFac(dataContrato.idEfectorFacturacion));
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const deleteDocumentoEfectorFac = (idTipoDocumentacionesEfectoresPorSubTipoEfector) => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      dispatch(startSpinner());

      const response = await ContratacionesService.eliminarDocumentacionXEfector(idTipoDocumentacionesEfectoresPorSubTipoEfector)
      const body = await response.json();
      if (response.ok) {
        dispatch(
          getDocumentoEfectorFac(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Documento Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const getDocumentoLegal = (idEfectorFacturacion) => {
  return async (dispatch) => {
    try {
      const response = await ContratacionesService.obtenerDocumentacionLegal(idEfectorFacturacion)
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.contratacionesGetDocumentacionLegal,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const setDocumentoLegal = (formData, idTipoDocumentacion) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/EfectorFacturacionDocumentacionLegal/${dataContrato.idEfectorFacturacion}/${idTipoDocumentacion}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentoLegal(dataContrato.idEfectorFacturacion));
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const deleteDocumentoLegal = (idDocumentacionLegal) => {
  return async (dispatch, getState) => {
    try {
      const { dataContrato } = getState().contrataciones;
      dispatch(startSpinner());

      const response = await ContratacionesService.eliminarDocumentacionLegal(idDocumentacionLegal)
      const body = await response.json();
      if (response.ok) {
        dispatch(
          getDocumentoLegal(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Documento Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};
